/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateRoleAssignment {
    getFixupPrototypeFunction() { return UpdateRoleAssignment.fixupPrototype; }

    static newInstance(model: Partial<UpdateRoleAssignment>): UpdateRoleAssignment {
        let obj = Object.assign(new UpdateRoleAssignment(), model);
        UpdateRoleAssignment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateRoleAssignment>): UpdateRoleAssignment {
        if (!model) return null;
        return UpdateRoleAssignment.newInstance(<UpdateRoleAssignment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateRoleAssignment) {
        if (!obj) return;

        models.UpdateRoleAssignment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateRoleAssignment): boolean {
        Object.setPrototypeOf(obj, UpdateRoleAssignment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant within the CoreStack account
     */
    tenant_id: string;

    /**
     * Id of the Roles to be assigned to the user under a tenant
     */
    roles: Array<string>;

}
